import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

const initialState = fromJS({
  notification: {
    title: "",
    message: "",
    action: "",
    type: "success",
    variant: "",
    duration: 3000,
  },
});

export const actions = {
  [ActionTypes.API_FAIL]: {
    next(state, { error = {} }) {
      const newState = {
        ...state.toJS(),
        notification: {
          message: error.message,
          title: "Error",
          type: "error",
        },
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.updateTask]: {
    next(state, { payload, pending }) {
      if (pending) {
        return state.merge({ pending });
      }
      const { fieldId } = payload;
      const newState = {
        ...state.toJS(),
        notification: {
          message: `${fieldId} field is updated.`,
          title: "Successfully saved",
          action: ActionTypes.updateTask,
          type: "success",
        },
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.updateProject]: {
    next(state, { pending }) {
      if (pending) {
        return state;
      }
      const newState = {
        ...state.toJS(),
        notification: {
          message: `Workspace is updated.`,
          title: "Successfully saved",
          action: ActionTypes.updateProject,
          type: "success",
        },
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.updateProjectField]: {
    next(state) {
      return state;
    },
  },
  [ActionTypes.setNotification]: {
    next(state, { payload }) {
      const newState = {
        ...state.toJS(),
        notification: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.clearNotification]: {
    next(state) {
      const newState = {
        ...state.toJS(),
        notification: initialState.get("notification").toJS(),
      };
      return fromJS(newState);
    },
  },
};

export const notification = handleActions(actions, initialState);
